import Vue from 'vue'
import Router from 'vue-router'
import index from '@/page/index'
import menuIndex from '@/components/menuIndex'
import submenu from '@/components/submenu'
import books from '@/page/books'
import required from '@/page/required'
import examination from '@/page/examination'
import video from '@/page/video'

Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/index',
      name: 'index',
      component: index,
      children: [
        {
          path: 'menuIndex',
          component: menuIndex
        },
        {
          path: 'submenu',
          component: submenu
        }
      ]
    },
    {
      path: '/books',
      name: 'books',
      component: books
    },
    {
      path: '/required',
      name: 'required',
      component: required
    },
    {
      path: '/examination',
      name: 'examination',
      component: examination
    },
    {
      path: '/video',
      component: video
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js